import React from 'react';

import { Textarea } from '@chakra-ui/react';
import InputBar from '../../../../../../../../../Common/InputBar';

import InputBarWithInitialI from '../../../../../../../InputBarWithInitialI';
import { FraudFlagDto } from '../../../../../../../../../../api/sms-backoffice-api';

interface Props {
  detectionType: string;
  value: string;
  value2?: string;
  note?: string;
  setValue: (value: string) => void;
  setValue2?: (value2: string) => void;
  setNote?: (note: string) => void;
  item?: FraudFlagDto;
}

const FraudInfoInput = ({
  detectionType,
  value,
  value2,
  note,
  setValue,
  setValue2,
  setNote,
  item,
}: Props) => {
  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let input = event.target.value;

    switch (detectionType) {
      case 'FULL_NAME':
        // shareholder name contains: letters, whitespace, periods (.), ampersands (&), apostrophes (') and hyphens (-)
        input = input.replace(/[^a-zA-Z\s.&'-]/g, '');
        break;
      case 'POSTCODE':
      case 'STOCK_CODE':
        input = input.replace(/[^a-zA-Z0-9]/g, '');
        break;
      default:
        break;
    }

    setValue(input);
  };

  const handleValue2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setValue2) {
      setValue2(event.target.value);
    }
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    const cleaned = raw.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
    setValue(cleaned);
  };

  const handleBSBChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let input = event.target.value;

    let raw = input.replace(/\D/g, '');

    if (raw.length > 6) raw = raw.slice(0, 6);

    const formatted = raw.length > 3 ? `${raw.slice(0, 3)}-${raw.slice(3)}` : raw;

    setValue(formatted);
  };

  return (
    <div>
      {detectionType === 'FULL_NAME' && (
        <InputBar
          inputName="Full Name"
          inputType="text"
          value={value}
          onChange={handleValueChange}
        />
      )}
      {detectionType === 'MOBILE' && (
        <InputBar inputName="Mobile" inputType="tel" value={value} onChange={handlePhoneChange} />
      )}
      {detectionType === 'EMAIL' && (
        <InputBar inputName="Email" inputType="text" value={value} onChange={handleValueChange} />
      )}

      {detectionType === 'SRN' && (
        <InputBarWithInitialI
          inputName="SRN"
          value={value}
          onChange={setValue}
          isUpdateMode={!!item?.id}
        />
      )}

      {detectionType === 'BANK_DETAILS' && (
        <>
          <InputBar
            inputName="BSB Number"
            inputType="text"
            value={value}
            onChange={handleBSBChange}
          />
          <InputBar
            inputName="Account Number"
            inputType="number"
            value={value2}
            onChange={handleValue2Change}
          />
        </>
      )}
      {detectionType === 'POSTCODE' && (
        <InputBar
          inputName="Shareholder Postcode"
          inputType="text"
          value={value}
          onChange={handleValueChange}
        />
      )}
      {detectionType === 'STOCK_CODE' && (
        <InputBar
          inputName="Stock Code"
          inputType="text"
          value={value}
          onChange={handleValueChange}
        />
      )}
      <div>Note:</div>
      <Textarea value={note} onChange={(e) => setNote?.(e.target.value)} size="lg" height="80px" />
    </div>
  );
};

export default FraudInfoInput;
